/* Krishna Bhog UX Phase 2 - header scroll shadow */
(function () {
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    var cls = "is-scrolled";
    var header = document.querySelector(".header-section, .header");
    if (!header) return;
    var parent = header.closest("#header-group, body");
    if (!parent) parent = document.body;
    if (y > 8) {
      parent.classList.add(cls);
    } else {
      parent.classList.remove(cls);
    }
  }
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  onScroll();
})();
